var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "80%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": false },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Generazione variazione"),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "data-test": "input-componente",
                                  rules: [(v) => !!v || "Componente richiesto"],
                                  autocomplete: "off",
                                  label: "Componente",
                                },
                                model: {
                                  value:
                                    _vm.nuovaVariazione.rigaDistinta
                                      .innerRigaDistinta.idComponenteBga,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nuovaVariazione.rigaDistinta
                                        .innerRigaDistinta,
                                      "idComponenteBga",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nuovaVariazione.rigaDistinta.innerRigaDistinta.idComponenteBga",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "data-test": "input-colore",
                                  autocomplete: "off",
                                  label: "Colore",
                                },
                                model: {
                                  value:
                                    _vm.nuovaVariazione.rigaDistinta
                                      .innerRigaDistinta.idColoreComponenteBgf,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nuovaVariazione.rigaDistinta
                                        .innerRigaDistinta,
                                      "idColoreComponenteBgf",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nuovaVariazione.rigaDistinta.innerRigaDistinta.idColoreComponenteBgf",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  rules: [
                                    (v) => !!v || "Unità di misura richiesta",
                                  ],
                                  autocomplete: "off",
                                  items: _vm.unitaDiMisura,
                                  label: "Unità di misura",
                                  "item-text": "desc",
                                  "item-value": "id",
                                  "data-test": "lista-unita-di-misura",
                                },
                                model: {
                                  value:
                                    _vm.nuovaVariazione.rigaDistinta
                                      .innerRigaDistinta.unMisuraDiBa,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.nuovaVariazione.rigaDistinta
                                        .innerRigaDistinta,
                                      "unMisuraDiBa",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "nuovaVariazione.rigaDistinta.innerRigaDistinta.unMisuraDiBa",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "col-dati",
                                  attrs: {
                                    "data-test": "tabella-crea-variazione",
                                  },
                                },
                                [
                                  _c("TabellaValori", {
                                    attrs: {
                                      rigaDistinta: _vm.nuovaVariazione,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("VariazioniMassive", {
                                attrs: {
                                  "variazione-riferimento": _vm.nuovaVariazione,
                                  variazioniCorrelate:
                                    _vm.nuovaVariazione.variazioniCorrelate,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "darken-1" },
                      on: { click: _vm.annullaVariazione },
                    },
                    [_vm._v("Annulla")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        text: "",
                        disabled: !_vm.valid,
                        "data-test": "crea-variazione",
                      },
                      on: { click: _vm.creaVariazione },
                    },
                    [_vm._v("Crea variazione")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }